module.exports = __webpack_public_path__ + "static/500+physicians-95a0cadc434814aa781ff76f6bc8c026.png";